document.addEventListener('DOMContentLoaded', initSliders);

// Listen for Shopify theme editor events
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initSliders);
  document.addEventListener('shopify:section:select', initSliders);
}

function initSliders() {
  // Initialize Swiper for article lists
  const articleSliders = document.querySelectorAll('.article-list[data-slider]');
  
  articleSliders.forEach(slider => {
    // Destroy existing swiper instance if it exists
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }
    
    // Create new Swiper instance
    new Swiper(slider, {
      slidesPerView: "auto",
      navigation: {
        nextEl: '.swiper-article-button-next',
        prevEl: '.swiper-article-button-prev'
      },
      spaceBetween: 14,
      autoHeight: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 0
        }
      }
    });
  });
}
